import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=9ccbe4e6&scoped=true&"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js&"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js&"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=9ccbe4e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccbe4e6",
  null
  
)

export default component.exports